(function($){

	var gallery = function(){
		$('.gallery-list').magnificPopup({
			delegate: 'a',
			type: 'image',
			image: {
				markup: '<div class="mfp-figure">'+
				'<div class="mfp-close"></div>'+
				'<div class="mfp-img"></div>'+
				// '<div class="mfp-arrows">' +
				// 	'<button title="Previous (Left arrow key)" type="button" class="mfp-arrow mfp-arrow-left"></button>' +
				// 	'<button title="Next (Right arrow key)" type="button" class="mfp-arrow mfp-arrow-right"></button>' +
				// '</div>'+
				'<div class="mfp-bottom-bar">'+
				'<div class="mfp-title">test</div>'+
				'</div>'+
				'</div>', 
				titleSrc: function(item){
					var content = item.el.attr('data-content');

					if(content != ''){
						content = '<div class="title-content">' + content + '</div>';
					}
					return content;
				},
				verticalFit: true
			},
			gallery: {
				enabled: true
			},
			callbacks: {
				buildControls: function() {
				// re-appends controls inside the main container
					this.contentContainer.find('.mfp-bottom-bar').append(this.arrowLeft.add(this.arrowRight));
				}
			}
			// arrows: false,
			// prevArrow: '.mfp-arrow-left',
			// nextArrow: '.mfp-arrow-right'
		});

	};
/*
	var scrollToAnchor = function(){

		if( location.hash ){
			// console.log(location.hash);

			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 0;
				
				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight();
					$("html, body").animate({scrollTop: finalPosition}, 1000);

					$( 'body' ).removeClass( 'nav-open' );
					// locationHashObj.addClass('active');

				}, waitTime);
			}
		}

		$('[href^="#"], .scroll-link, .nav-scroll-link > a, .nav-scroll-link > .ocn-link-wrap > a, .tab-section-list a').on('click', function(e){

			var hashTarget = $(this.hash);

			if( hashTarget.length ){
				e.preventDefault();
				var waitTime = 0;
				var thisTopParent = $(this).parents('.menu-item-has-children');

				
				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				if(thisTopParent.length){
					thisTopParent.addClass('unhover');
				}
				
				$( 'body' ).removeClass( 'nav-open' );


				setTimeout(function(){
					var anchorPosition = hashTarget.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight();
					$("html, body").animate({
						scrollTop: finalPosition
					}, 1000, function(){

						if(thisTopParent.length){
							thisTopParent.removeClass('unhover');
						}
					});
					hashTarget.addClass('active');
					

				}, waitTime);
			}
		});
	};*/

	$(document).ready(function(){
		// scrollToAnchor();
		gallery();
	});

})(jQuery);